import { lazy } from "react";
import { Route } from "wouter";
import type { RouteHelpers } from "./types";

const AiEventsApp = lazy(() => import("@/pages/ai-events/AiEventsApp"));

const CompanionApp = lazy(() => import("@/pages/companion/CompanionApp"));
const CompanionLanding = lazy(() => import("@/pages/companion/CompanionLanding"));
const CompanionEventsOverview = lazy(() => import("@/pages/companion/CompanionEventsOverview"));
const CompanionEventDetail = lazy(() => import("@/pages/companion/CompanionDetailPages"));
const CompanionSpeakerDetail = lazy(() => import("@/pages/companion/CompanionDetailPages").then((m) => ({ default: m.CompanionSpeakerDetail })));
const CompanionHostDetail = lazy(() => import("@/pages/companion/CompanionDetailPages").then((m) => ({ default: m.CompanionHostDetail })));
const CompanionCollection = lazy(() => import("@/pages/companion/CompanionDetailPages").then((m) => ({ default: m.CompanionCollection })));
const CompanionApply = lazy(() => import("@/pages/companion/CompanionApply"));

export function CompanionRoutes({ LazyRoute }: RouteHelpers) {
  return (
    <>
      {/* Global primary events must be matched before edition-scoped companions. */}
      {["", "/discover", "/map", "/virtual", "/sessions", "/itinerary", "/companies", "/people", "/profile", "/event/:id", "/session/:eventId/:sessionId", "/company/:id", "/person/:id"].map((suffix) => (
        <Route key={`ai-events${suffix}`} path={`/companion/ai-events${suffix}`}>
          {() => <LazyRoute component={AiEventsApp} />}
        </Route>
      ))}
      {/* events.chiefinai.com hub — must precede :subdomain so it isn't read as an edition */}
      <Route path="/companion/events-overview">
        {() => <LazyRoute component={CompanionEventsOverview} />}
      </Route>
      {/* Detail pages */}
      <Route path="/companion/:subdomain/apply/:slug">
        {() => <LazyRoute component={CompanionApply} />}
      </Route>
      <Route path="/companion/:subdomain/events/:slug">
        {() => <LazyRoute component={CompanionEventDetail} />}
      </Route>
      <Route path="/companion/:subdomain/speaker/:slug">
        {() => <LazyRoute component={CompanionSpeakerDetail} />}
      </Route>
      <Route path="/companion/:subdomain/host/:slug">
        {() => <LazyRoute component={CompanionHostDetail} />}
      </Route>
      {/* Collection pages */}
      {["popular", "speakers/popular", "speakers", "c/:slug", "for/:slug", "access/:slug", "day/:slug", "venue/:slug", "topic/:slug", "roles/:slug", "company/:slug", "people/:slug"].map((p) => (
        <Route key={p} path={`/companion/:subdomain/${p}`}>
          {() => <LazyRoute component={CompanionCollection} />}
        </Route>
      ))}
      {/* Edition root → standalone SEO landing page. */}
      <Route path="/companion/:subdomain">
        {() => <LazyRoute component={CompanionLanding} />}
      </Route>
      {/* Exact app tabs. Unknown paths fall through to the platform NotFound route. */}
      {["discover", "map", "itinerary", "people", "profile"].map((tab) => (
        <Route key={tab} path={`/companion/:subdomain/${tab}`}>
          {() => <LazyRoute component={CompanionApp} />}
        </Route>
      ))}
    </>
  );
}
